import { useEffect, useState } from 'react'
import { useRecoilState } from 'recoil'

import { isPresent } from 'utils'

import collectionProductToProductCardSmallProps from 'converters/collectionProductToProductCardSmallProps'

import { productHistoryStorageAtom } from 'state/atoms'

import Button from 'components/Button'
import ProductCardSmall from 'components/ProductCardSmall'
import SubHeader from 'components/SubHeader'

import { Header, Main, Product, Products, Root } from './ProductHistory.style'

const variants = {
  visible: {
    y: '0%',
  },
  hidden: {
    y: '100%',
  },
}

const ProductHistory = () => {
  // const productHistorySession = useRecoilValue(productHistorySessionAtom)
  const [productHistoryStorage, setProductHistoryStorage] = useRecoilState(productHistoryStorageAtom)

  const [visible, setVisible] = useState(false)
  const [products, setProducts] = useState([])

  useEffect(() => {
    ;(async () => {
      // const response = await fetch(`/api/productsByHandle?handle=${productHistoryStorage.join(',')}`)
      const response = await fetch(
        `/api/productsByHandle?handle=${[
          'merino-wool-harbour-sweater',
          'vegetable-tanned-calf-card-holder',
          'sagan-stride-loafer',
        ].join(',')}`
      )
      const json = await response.json()
      setProducts(json)

      if (isPresent(json)) setTimeout(() => setVisible(true), 300)
    })()
  }, [productHistoryStorage])

  const handleClose = () => {
    setProductHistoryStorage([])
  }

  // if (equals(productHistorySession, productHistoryStorage)) return null

  return (
    <Root variants={variants} animate={visible ? 'visible' : 'hidden'}>
      <Header>
        <SubHeader>Last time, you looked at…</SubHeader>
        <Button text="Close" variant="inline" onClick={handleClose} />
      </Header>
      <Main>
        <Products>
          {products.map(collectionProductToProductCardSmallProps)?.map((product, index) => (
            <Product key={index}>
              <ProductCardSmall {...product} />
            </Product>
          ))}
        </Products>
      </Main>
    </Root>
  )
}

ProductHistory.propTypes = {}

ProductHistory.defaultProps = {}

export default ProductHistory
